module.exports = __webpack_public_path__ + "static/media/play.34df3111.svg";